// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* COLORS */
/* MEASUREMENTS */
.attachment-group .form-control[data-v-3f73c283] {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.attachment-bar[data-v-3f73c283] {
  display: flex;
  align-items: center;
  background: #f5f5f5;
  padding: 2.5px;
  border: 1px solid #ced4da;
  border-top: none;
  border-radius: 0 0 0.25rem 0.25rem;
}
.attachment-bar[data-v-3f73c283]:before {
  position: absolute;
  font-size: 1.1em;
  padding: 7.5px 7.5px 5px 5px;
  pointer-events: none;
}
.attachment-bar input[data-v-3f73c283] {
  display: flex;
  padding-left: 30px;
  font-size: 0.85em;
}
.visibility-input-wrapper[data-v-3f73c283] {
  display: flex;
  align-items: center;
  position: relative;
  width: auto;
  height: auto;
  padding: 0;
  font-size: 0.9em;
}
.visibility-input-wrapper .icon[data-v-3f73c283]:before {
  margin-right: 5px;
}
.visibility-input-wrapper .btn[data-v-3f73c283] {
  display: flex;
  align-items: center;
  padding: 0 4px;
}
.icon-sites[data-v-3f73c283]:before {
  color: #3f51b5;
}
.disabled-visibility[data-v-3f73c283] {
  cursor: not-allowed !important;
}
.disabled-visibility .visibility-input[data-v-3f73c283] {
  pointer-events: none;
}
.dropdown-menu[data-v-3f73c283] {
  right: 0;
  left: auto;
  white-space: nowrap;
  padding: 10px 15px;
  font-size: 0.875rem;
}
.dropdown-menu .icon[data-v-3f73c283] {
  display: inline-flex;
  align-items: center;
}
.comment-username[data-v-3f73c283] {
  display: block;
  line-height: 100%;
  margin-bottom: 5px;
}
.comment-list[data-v-3f73c283] {
  padding: 0;
  margin: 0 0 5px 0;
  list-style: none;
}
.comment-list-heading[data-v-3f73c283] {
  display: block;
  margin-top: 0;
  margin-bottom: 20px;
}
.comment-card[data-v-3f73c283] {
  margin-top: 5px;
  display: block;
  padding: 7.5px;
  float: left;
  width: 100%;
}
.comment-btn[data-v-3f73c283] {
  margin-top: 7.5px;
}
.comment-icon-btn[data-v-3f73c283] {
  display: inline-block;
  margin-top: 5px;
  padding: 0;
  text-decoration: none !important;
  line-height: 0;
  font-size: 1.1em;
}
.submissions-comment[data-v-3f73c283] {
  padding: 10px;
  border-bottom: 1px solid #cccccc;
}
.submissions-comment .comment-text[data-v-3f73c283] {
  margin: 0;
}
.submissions-comment .help-block[data-v-3f73c283] {
  white-space: nowrap;
  display: block;
}
.submissions-comment[data-v-3f73c283]:first-of-type {
  margin-top: 0;
}
.btn-outline-secondary[data-v-3f73c283]:not(:focus, :hover) {
  background-color: #ffffff;
}
.btn-bare[data-v-3f73c283] {
  font-weight: bold;
  font-size: 16px;
}
[data-v-3f73c283] .help-button {
  margin-right: 5px;
  cursor: not-allowed;
}
[data-v-3f73c283] .disabled-help-overlay .help-button .icon {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 30px;
  background: none;
  outline: none !important;
}
[data-v-3f73c283] .disabled-help-overlay .help-button .icon:before {
  display: none;
}
[data-v-3f73c283] .disabled-help-overlay .popper {
  min-width: 200px;
}
.field-validation-error .icon.icon-attention[data-v-3f73c283] {
  color: inherit;
}
`, "",{"version":3,"sources":["webpack://./../Comments.3.vue","webpack://./public/pages/elementTemplates/Comments.3.vue"],"names":[],"mappings":"AAAA,WAAW;AACX,iBAAiB;ACCjB;EAEQ,6BAAA;EACA,4BAAA;ADAR;ACGA;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA;EACA,kCAAA;ADDJ;ACEI;EACI,kBAAA;EACA,gBAAA;EACA,4BAAA;EACA,oBAAA;ADAR;ACZA;EAeQ,aAAA;EACA,kBAAA;EACA,iBAAA;ADAR;ACGA;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;ADDJ;ACGQ;EACI,iBAAA;ADDZ;ACTA;EAcQ,aAAA;EACA,mBAAA;EACA,cAAA;ADFR;ACKA;EACI,cAAA;ADHJ;ACKA;EACI,8BAAA;ADHJ;ACEA;EAGQ,oBAAA;ADFR;ACKA;EACI,QAAA;EACA,UAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;ADHJ;ACFA;EAOQ,oBAAA;EACA,mBAAA;ADFR;ACKA;EACI,cAAA;EACA,iBAAA;EACA,kBAAA;ADHJ;ACKA;EACI,UAAA;EACA,iBAAA;EACA,gBAAA;ADHJ;ACKA;EACI,cAAA;EACA,aAAA;EACA,mBAAA;ADHJ;ACKA;EACI,eAAA;EACA,cAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;ADHJ;ACKA;EACI,iBAAA;ADHJ;ACKA;EACI,qBAAA;EACA,eAAA;EACA,UAAA;EACA,gCAAA;EACA,cAAA;EACA,gBAAA;ADHJ;ACKA;EACI,aAAA;EACA,gCAAA;ADHJ;ACCA;EAIQ,SAAA;ADFR;ACFA;EAOQ,mBAAA;EACA,cAAA;ADFR;ACII;EACI,aAAA;ADFR;ACMI;EACI,yBAAA;ADJR;ACOA;EACI,iBAAA;EACA,eAAA;ADLJ;ACOA;EACI,iBAAA;EACA,mBAAA;ADLJ;ACOA;EAGQ,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,wBAAA;ADPR;ACQQ;EACI,aAAA;ADNZ;ACLA;EAeQ,gBAAA;ADPR;ACUA;EAEQ,cAAA;ADTR","sourcesContent":["/* COLORS */\n/* MEASUREMENTS */\n.attachment-group .form-control {\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.attachment-bar {\n  display: flex;\n  align-items: center;\n  background: #f5f5f5;\n  padding: 2.5px;\n  border: 1px solid #ced4da;\n  border-top: none;\n  border-radius: 0 0 0.25rem 0.25rem;\n}\n.attachment-bar:before {\n  position: absolute;\n  font-size: 1.1em;\n  padding: 7.5px 7.5px 5px 5px;\n  pointer-events: none;\n}\n.attachment-bar input {\n  display: flex;\n  padding-left: 30px;\n  font-size: 0.85em;\n}\n.visibility-input-wrapper {\n  display: flex;\n  align-items: center;\n  position: relative;\n  width: auto;\n  height: auto;\n  padding: 0;\n  font-size: 0.9em;\n}\n.visibility-input-wrapper .icon:before {\n  margin-right: 5px;\n}\n.visibility-input-wrapper .btn {\n  display: flex;\n  align-items: center;\n  padding: 0 4px;\n}\n.icon-sites:before {\n  color: #3f51b5;\n}\n.disabled-visibility {\n  cursor: not-allowed !important;\n}\n.disabled-visibility .visibility-input {\n  pointer-events: none;\n}\n.dropdown-menu {\n  right: 0;\n  left: auto;\n  white-space: nowrap;\n  padding: 10px 15px;\n  font-size: 0.875rem;\n}\n.dropdown-menu .icon {\n  display: inline-flex;\n  align-items: center;\n}\n.comment-username {\n  display: block;\n  line-height: 100%;\n  margin-bottom: 5px;\n}\n.comment-list {\n  padding: 0;\n  margin: 0 0 5px 0;\n  list-style: none;\n}\n.comment-list-heading {\n  display: block;\n  margin-top: 0;\n  margin-bottom: 20px;\n}\n.comment-card {\n  margin-top: 5px;\n  display: block;\n  padding: 7.5px;\n  float: left;\n  width: 100%;\n}\n.comment-btn {\n  margin-top: 7.5px;\n}\n.comment-icon-btn {\n  display: inline-block;\n  margin-top: 5px;\n  padding: 0;\n  text-decoration: none !important;\n  line-height: 0;\n  font-size: 1.1em;\n}\n.submissions-comment {\n  padding: 10px;\n  border-bottom: 1px solid #cccccc;\n}\n.submissions-comment .comment-text {\n  margin: 0;\n}\n.submissions-comment .help-block {\n  white-space: nowrap;\n  display: block;\n}\n.submissions-comment:first-of-type {\n  margin-top: 0;\n}\n.btn-outline-secondary:not(:focus, :hover) {\n  background-color: #ffffff;\n}\n.btn-bare {\n  font-weight: bold;\n  font-size: 16px;\n}\n /deep/ .help-button {\n  margin-right: 5px;\n  cursor: not-allowed;\n}\n /deep/ .disabled-help-overlay .help-button .icon {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 30px;\n  background: none;\n  outline: none !important;\n}\n /deep/ .disabled-help-overlay .help-button .icon:before {\n  display: none;\n}\n /deep/ .disabled-help-overlay .popper {\n  min-width: 200px;\n}\n.field-validation-error .icon.icon-attention {\n  color: inherit;\n}\n","\n@import \"/lib/Colors.less\";\n.attachment-group {\n    .form-control {\n        border-bottom-right-radius: 0;\n        border-bottom-left-radius: 0;\n    }\n}\n.attachment-bar {\n    display: flex;\n    align-items: center;\n    background: #f5f5f5;\n    padding: 2.5px;\n    border: 1px solid #ced4da;\n    border-top: none;\n    border-radius: 0 0 0.25rem 0.25rem;\n    &:before {\n        position: absolute;\n        font-size: 1.1em;\n        padding: 7.5px 7.5px 5px 5px;\n        pointer-events: none;\n    }\n    input {\n        display: flex;\n        padding-left: 30px;\n        font-size: 0.85em;\n    }\n}\n.visibility-input-wrapper {\n    display: flex;\n    align-items: center;\n    position: relative;\n    width: auto;\n    height: auto;\n    padding: 0;\n    font-size: 0.9em;\n    .icon {\n        &:before {\n            margin-right: 5px;\n        }\n    }\n    .btn {\n        display: flex;\n        align-items: center;\n        padding: 0 4px;\n    }\n}\n.icon-sites:before {\n    color: @primary-blue-v2;\n}\n.disabled-visibility {\n    cursor: not-allowed !important;\n    .visibility-input {\n        pointer-events: none;\n    }\n}\n.dropdown-menu {\n    right: 0;\n    left: auto;\n    white-space: nowrap;\n    padding: 10px 15px;\n    font-size: 0.875rem;\n    .icon {\n        display: inline-flex;\n        align-items: center;\n    }\n}\n.comment-username {\n    display: block;\n    line-height: 100%;\n    margin-bottom: 5px;\n}\n.comment-list {\n    padding: 0;\n    margin: 0 0 5px 0;\n    list-style: none;\n}\n.comment-list-heading {\n    display: block;\n    margin-top: 0;\n    margin-bottom: 20px;\n}\n.comment-card {\n    margin-top: 5px;\n    display: block;\n    padding: 7.5px;\n    float: left;\n    width: 100%;\n}\n.comment-btn {\n    margin-top: 7.5px;\n}\n.comment-icon-btn {\n    display: inline-block;\n    margin-top: 5px;\n    padding: 0;\n    text-decoration: none !important;\n    line-height: 0;\n    font-size: 1.1em;\n}\n.submissions-comment {\n    padding: 10px;\n    border-bottom: 1px solid #cccccc;\n    .comment-text {\n        margin: 0;\n    }\n    .help-block {\n        white-space: nowrap;\n        display: block;\n    }\n    &:first-of-type {\n        margin-top: 0;\n    }\n}\n.btn-outline-secondary {\n    &:not(:focus, :hover) {\n        background-color: #ffffff;\n    }\n}\n.btn-bare {\n    font-weight: bold;\n    font-size: 16px;\n}\n/deep/ .help-button {\n    margin-right: 5px;\n    cursor: not-allowed;\n}\n/deep/ .disabled-help-overlay {\n    // overlay help icon on disabled inputs for better reliability on click\n    .help-button .icon {\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 30px;\n        background: none;\n        outline: none !important;\n        &:before {\n            display: none;\n        }\n    }\n    .popper {\n        min-width: 200px;\n    }\n}\n.field-validation-error {\n    .icon.icon-attention {\n        color: inherit;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
